import {
  Box,
  Button,
  ButtonBase,
  IconButton,
  Table,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  Add,
  ArrowDownward,
  ArrowUpward,
  RemoveCircle,
} from '@material-ui/icons';
import {
  getGradient,
  getindexGradientId,
} from 'components/DynamicScreen/CardWidgets/BasicWidgets';
import React from 'react';
import ConditionalSelectionField from './FieldTypes/ConditionalSelectionField';
import { TextInputField } from './FieldTypes/TextInputField';

export const subOptionFormAvailable = [700, 800];

const ItemPreviewRendererds = {
  700: ({ item, index }) => (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={3}
      py={1}
      style={{
        background:
          getGradient(item.gradientId || getindexGradientId(index)) ||
          '#f8f8f8',
        boxShadow: '0px 3px 6px #00000029',
        marginRight: 16,
        borderRadius: 5,
        border: 'none',
        margin: 5,
        maxWidth: '100%',
        textAlign: 'center',
      }}
    >
      <Typography
        style={{
          color: '#ffffff',
          overflow: 'hidden',
          wordWrap: 'break-word',
          whiteSpace: 'normal',
          maxWidth: '100%',
          textAlign: 'center',
        }}
      >
        {`${item.option}${
          !isNaN(item.score) && item.score !== null ? ` (${item.score})` : ''
        }`}
      </Typography>
    </Box>
  ),
  800: ({ item, index }) =>
    (item.min !== undefined && item.min !== null) ||
    (item.min !== undefined && item.min !== null) ? (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={3}
        py={1}
        style={{
          background:
            getGradient(item.gradientId || getindexGradientId(index)) ||
            '#f8f8f8',
          boxShadow: '0px 3px 6px #00000029',
          marginRight: 16,
          borderRadius: 5,
          border: 'none',
          margin: 5,
          maxWidth: '100%',
          textAlign: 'center',
        }}
      >
        {!isNaN(item.min) && item.min !== null && (
          <div
            style={{
              display: 'flex',
              marginRight: 7,
              alignItems: 'center',
              paddingRight: 2,
            }}
          >
            <ArrowDownward style={{ color: '#ffffff', fontSize: 15 }} />
            <Typography
              style={{
                color: '#ffffff',
                overflow: 'hidden',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                maxWidth: '100%',
              }}
            >
              {item.min}
            </Typography>
          </div>
        )}
        {!isNaN(item.max) && item.max !== null && (
          <div
            style={{
              display: 'flex',
              marginRight: 7,
              alignItems: 'center',
              paddingRight: 2,
            }}
          >
            <ArrowUpward style={{ color: '#ffffff', fontSize: 15 }} />
            <Typography
              style={{
                color: '#ffffff',
                overflow: 'hidden',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                maxWidth: '100%',
              }}
            >
              {item.max}
            </Typography>
          </div>
        )}
        {!isNaN(item.score) && item.score !== null && (
          <Typography
            style={{
              color: '#ffffff',
              overflow: 'hidden',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}
          >
            {` Score: ${item.score}`}
          </Typography>
        )}
      </Box>
    ) : null,
};

const InputFieldTypes = {
  0: TextInputField,
  1: TextInputField,
  2: TextInputField,
  3: TextInputField,
  4: TextInputField,
  5: TextInputField,
  6: TextInputField,
  7: TextInputField,
  8: TextInputField,
  9: TextInputField,
  102: ConditionalSelectionField,
};

const RenderForm = ({
  item,
  column,
  inSideDrawer,
  onChange,
  itemIndex,
  formFields,
}) =>
  formFields.map((field, index) => {
    const RenderField = InputFieldTypes[field.inputAllowed];
    return (
      <RenderField
        size="small"
        value={item[field.key]}
        {...{ ...(field || {}), _key: (field || {}).key }}
        column={column}
        helperText={inSideDrawer ? undefined : 'Press enter to save'}
        minimalForm={inSideDrawer}
        field={field}
        onChange={(value) =>
          onChange(
            {
              ...item,
              [field.key]: [3, 4, 7].includes(field.inputAllowed)
                ? /^\d+$/.test(value)
                  ? +value
                  : null
                : value,
            },
            itemIndex
          )
        }
        autoFocus={index === 0 && itemIndex === 0}
        fullWidth
      />
    );
  });

const SubOptionForm = ({
  row,
  column,
  content,
  selectedOption,
  onChange,
  removeItem,
  rowState,
  horizontal,
  addOptionEnabled,
  inSideDrawer,
  commitFinalValues,
}) => {
  const [adding, setAdding] = React.useState(false);
  const [newValue, setNewValue] = React.useState(
    ((selectedOption || {}).inputFields || []).reduce(
      (state, field) => ({ ...state, [field.key]: null }),
      {}
    )
  );
  let inputFieldRef = React.useRef();
  const optionalFields = (
    (selectedOption || {}).inputFields || []
  ).filter((field) => (column.optionalFields || []).includes(field.key));
  const coreFields = ((selectedOption || {}).inputFields || []).filter(
    (field) => !(column.optionalFields || []).includes(field.key)
  );

  const finishAdding = () => {
    onChange(newValue, (content || []).length);
    setNewValue(
      ((selectedOption || {}).inputFields || []).reduce(
        (state, field) => ({ ...state, [field.key]: null }),
        {}
      )
    );
    setAdding(false);
  };

  React.useEffect(() => {
    inputFieldRef.current && inputFieldRef.current.focus();
  }, [adding]);

  const onKeyPress = (e, field) => {
    const regex = /^[0-9.]+$/;
    if ([3, 4, 7].includes(field.inputAllowed) && !regex.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === 'Enter') {
      finishAdding();
    }
  };

  const RenderComponent = inSideDrawer ? (
    <div>
      <Typography
        style={{
          color: '#747474',
          letterSpacing: 1.2,
          fontSize: 20,
          fontWeight: 'normal',
          marginBottom: 20,
        }}
      >
        {selectedOption.title}
      </Typography>
      <Table style={{ border: '1px solid #e0e0e0' }}>
        {(content || []).map((item, index) => {
          const ItemPreview =
            ItemPreviewRendererds[
              (rowState || {})[column.key] ||
                ((row || {})[column.key] || {}).value
            ];
          return (
            <TableRow>
              {ItemPreviewRendererds && (
                <TableCell style={{ padding: '10px 10px' }}>
                  <ItemPreview item={item} index={index} />
                </TableCell>
              )}
              <TableCell style={{ padding: '10px 0px' }}>
                <div
                  style={{
                    padding: '0px 10px',
                    ...(ItemPreview ? { borderLeft: '1px solid #e0e0e0' } : {}),
                  }}
                >
                  <RenderForm
                    {...{
                      item,
                      selectedOption,
                      column,
                      onChange,
                      formFields: optionalFields,
                      inSideDrawer,
                      itemIndex: index,
                    }}
                  />
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </Table>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: 20,
        }}
      >
        <Button
          style={{
            background:
              'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
            boxShadow: '0px 3px 6px #00000029',
            borderRadius: 5,
            border: 'none',
            margin: 5,
            color: '#ffffff',
            maxWidth: '100%',
            textAlign: 'center',
            color: '#ffffff',
            overflow: 'hidden',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            fontSize: '1rem',
            minWidth: 80,
          }}
          onClick={() => {
            commitFinalValues(content);
          }}
        >
          Save
        </Button>
      </div>
    </div>
  ) : (
    (content || []).map((item, index) => (
      <div
        style={{
          width: 500,
          maxWidth: 550,
          ...(horizontal || !inSideDrawer
            ? {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }
            : {}),
        }}
      >
        <RenderForm
          {...{
            item,
            selectedOption,
            column,
            onChange,
            formFields: coreFields,
            inSideDrawer,
            itemIndex: index,
          }}
        />
        <IconButton>
          <RemoveCircle
            onClick={() => removeItem(index)}
            style={{ color: '#b70000', fontSize: 17.5 }}
          />
        </IconButton>
      </div>
    ))
  );

  return (
    <Box>
      {RenderComponent}
      {adding &&
        (selectedOption || {}).inputFields.map((field) =>
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(field.inputAllowed) ? (
            <TextField
              inputRef={inputFieldRef}
              helperText={'Press enter to save'}
              placeholder={field.title}
              value={newValue[field.key]}
              column={column}
              inputProps={{
                maxLength: selectedOption.maxLength || 4,
              }}
              onChange={(event) =>
                setNewValue({
                  ...newValue,
                  [field.key]: [3, 4, 7].includes(field.inputAllowed)
                    ? +event.target.value
                    : event.target.value,
                })
              }
              onKeyPress={(e) => onKeyPress(e, field)}
              inputProps={{
                maxLength: field.maxLength,
              }}
              style={{
                margin: 5,
                maxWidth: '30%',
              }}
            />
          ) : null
        )}
      {(content || []).length < (selectedOption.maxLimit || 4) &&
        !adding &&
        addOptionEnabled !== false && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              style={{ color: '#7467F0' }}
              onClick={() => setAdding(true)}
            >
              + Add New
            </Button>
          </div>
        )}
    </Box>
  );
};

export default SubOptionForm;
